import React from "react"

const QuickorderHead = ( ) => {
  return (
   <React.Fragment>
     <colgroup>
       <col width="30"/>
       <col width="35%"/>
       <col width="20%"/>
       <col width="15%"/>
       <col width="15%"/>
       <col width="15%"/>
       <col width="10%"/>
     </colgroup>
     <thead>
     <tr>
       <th>&nbsp;</th>
       <th>{translate( "article" )}</th>
       <th>{translate( "Lieferbar" )}</th>
       <th>{translate("KE pro VE")}</th>
       <th>{translate("Brutto EK* pro VE")}</th>
       <th>{translate( "Summe Brutto EK*" )}</th>
       {/*<th>{translate( "PU" )}</th>*/}
       <th>&nbsp;</th>
       <th className="">
           {translate( "Menge in VE" )}
       </th>
     </tr>
     </thead>
   </React.Fragment>
  )
}


export default QuickorderHead


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Quickorder/QuickorderHead.js